// extracted by mini-css-extract-plugin
module.exports = {"wishlistModalTitle":"WishlistModalOrder_wishlistModalTitle__7MsI1"};